import React, { useEffect, useState } from 'react'
import './Static.css'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const Static = (props) => {
    const [staticPage, setStaticPage] = useState('')
    const [loading, setLoading] = useState(true)

    const getStaticPageData = global?.staticDetails || []

    useEffect(() => {
        // Find the page that matches the current pathname
        const page = getStaticPageData.find((data) => data.pathname === props.location.pathname)

        if (page) {
            setStaticPage(page)
        } else {
            setStaticPage('<p>Page not found</p>')
        }

        setLoading(false)
        window.scrollTo(0, 0)
    }, [props.location.pathname, getStaticPageData])

    if (loading) {
        return (
            <Layout>
                <div className="stcPgWrpr">Loading...</div>
            </Layout>
        )
    }

    return (
        <>
            <SEOTAG page={staticPage.seo_title} />
            <Layout>
                <div className="px-5 py-4 stctPgWrpr">
                    {/* <div className="gfContactBanner" style={{ marginTop: '0px' }}>
                        <h2 className="bannertext">{staticPage.title}</h2>
                    </div> */}
                    <section className="sectionContainer" style={{ marginTop: '32px' }}>
                        {/* <h4 className="binsTit">{staticPage.title}</h4> */}

                        <div className="binsDescBox">
                            <p
                                className="pTag mb-4"
                                dangerouslySetInnerHTML={{ __html: staticPage.description }}
                            ></p>
                        </div>
                    </section>
                </div>
            </Layout>
        </>
    )
}

export default Static
